module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoadingData) ? _c('div', [_vm._m(0), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activePaperType),
      callback: function($$v) {
        _vm.activePaperType = $$v
      },
      expression: "activePaperType"
    }
  }, _vm._l((_vm.eventPaperTypes), function(paperType, paperTypeIndex) {
    return _c('el-tab-pane', {
      attrs: {
        "label": paperType.paper_type.name,
        "name": 'tab_' + paperType.id
      }
    }, [_c('el-form', {
      ref: "formSelectPaperType",
      refInFor: true,
      attrs: {
        "label-position": "top"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Adicionar Avaliação"
      }
    }, [_c('el-select', {
      staticClass: "el-select-full",
      attrs: {
        "filterable": "",
        "clearable": "",
        "placeholder": "Selecione uma avaliação",
        "empty-text": "Nenhum registro encontrado"
      },
      on: {
        "change": function($event) {
          _vm.selectEvaluation(_vm.evaluationSelect, paperTypeIndex)
        }
      },
      model: {
        value: (_vm.evaluationSelect),
        callback: function($$v) {
          _vm.evaluationSelect = $$v
        },
        expression: "evaluationSelect"
      }
    }, _vm._l((_vm.dependencies.evaluation_types), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "disabled": _vm.checkEvaluationSelected(item.id, paperTypeIndex),
          "label": item.name,
          "value": item.id
        }
      })
    }))], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("Tipos de Avaliação")]), _vm._v(" "), _c('table', {
      staticClass: "custom-table-list paper-types-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Avaliação")]), _vm._v(" "), _c('th', [_vm._v("Período de Avaliação")]), _vm._v(" "), _c('th', [_vm._v("Critérios")]), _vm._v(" "), _c('th', {
      attrs: {
        "width": "130"
      }
    }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((paperType.evaluation_types), function(evaluation) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(evaluation.evaluation_type.name))]), _vm._v(" "), _c('td', [_c('div', [_c('strong', [_vm._v("Início:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(evaluation.start_datetime)))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Término:")]), _vm._v(" " + _vm._s(_vm._f("dateTimeEnToBr")(evaluation.end_datetime)))])]), _vm._v(" "), _c('td', [_c('ul', _vm._l((evaluation.criterias), function(evaluationCriteria) {
        return _c('li', [_vm._v("\n                                " + _vm._s(evaluationCriteria.criteria.name) + "\n                            ")])
      }))]), _vm._v(" "), _c('td', {
        staticClass: "buttons"
      }, [_c('el-button', {
        staticClass: "edit-paper-type",
        attrs: {
          "type": "info",
          "title": "Editar Tipo de Trabalho"
        },
        on: {
          "click": function($event) {
            _vm.editEvaluation(evaluation)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-edit"
      })]), _vm._v(" "), _c('el-button', {
        attrs: {
          "type": "danger",
          "title": "Remover Tipo de Trabalho"
        },
        on: {
          "click": function($event) {
            _vm.removeEvaluation(evaluation, paperTypeIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times"
      })])], 1)])
    }))])], 1)
  })), _vm._v(" "), (_vm.modalEvaluationVisible) ? _c('el-dialog', {
    attrs: {
      "title": 'Dados da avaliação: ' + _vm.evaluation.evaluation_type.name,
      "top": "5vh",
      "visible": _vm.modalEvaluationVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.modalEvaluationVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formEvaluation",
    staticClass: "form-paper-type",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.evaluation.start_datetime.$error
    },
    attrs: {
      "label": "Data/Hora Início da Avaliação"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "placeholder": "Data/Hora Início"
    },
    on: {
      "input": function($event) {
        _vm.$v.evaluation.start_datetime.$touch()
      }
    },
    model: {
      value: (_vm.evaluation.start_datetime),
      callback: function($$v) {
        _vm.$set(_vm.evaluation, "start_datetime", $$v)
      },
      expression: "evaluation.start_datetime"
    }
  }), _vm._v(" "), (!_vm.$v.evaluation.start_datetime.required && _vm.$v.evaluation.start_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.evaluation.end_datetime.$error
    },
    attrs: {
      "label": "Data/Hora Término da Avaliação"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "placeholder": "Data/Hora Término"
    },
    on: {
      "input": function($event) {
        _vm.$v.evaluation.end_datetime.$touch()
      }
    },
    model: {
      value: (_vm.evaluation.end_datetime),
      callback: function($$v) {
        _vm.$set(_vm.evaluation, "end_datetime", $$v)
      },
      expression: "evaluation.end_datetime"
    }
  }), _vm._v(" "), (!_vm.$v.evaluation.end_datetime.required && _vm.$v.evaluation.end_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nº Mínimo de avaliações"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "max": 100
    },
    model: {
      value: (_vm.evaluation.min_evaluations_number),
      callback: function($$v) {
        _vm.$set(_vm.evaluation, "min_evaluations_number", $$v)
      },
      expression: "evaluation.min_evaluations_number"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nota Mínima para Aprovação"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 0.1,
      "max": 10
    },
    model: {
      value: (_vm.evaluation.min_evaluation_next_step),
      callback: function($$v) {
        _vm.$set(_vm.evaluation, "min_evaluation_next_step", $$v)
      },
      expression: "evaluation.min_evaluation_next_step"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("Critérios de Avaliação")]), _vm._v(" "), _c('div', {
    staticClass: "fields-check"
  }, _vm._l((_vm.evaluation.criterias), function(criteria) {
    return _c('div', {
      staticClass: "item",
      class: {
        '-checked': criteria.checked
      },
      on: {
        "click": function($event) {
          criteria.checked = !criteria.checked
        }
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(criteria.name))]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(criteria.description))]), _vm._v(" "), (criteria.type === 'number') ? _c('div', {
      staticClass: "size"
    }, [_vm._v("\n                        Nota Mínima: " + _vm._s(criteria.min_size) + " / Nota Máxima: " + _vm._s(criteria.max_size) + "\n                    ")]) : _vm._e()])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "submit",
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.evaluation.$invalid
    },
    on: {
      "click": _vm.onSaveEvaluation
    }
  }, [_vm._v("\n                Salvar Alterações\n            ")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.onHandleModalEvaluation
    }
  }, [_vm._v("Fechar")])], 1)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-flex"
  }, [_c('h2', [_vm._v("Tipos de Trabalhos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1829c79d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/form/Evaluations.vue
// module id = 723
// module chunks = 2